
    var riot = require('riot')
    //src: starling/src/tags/zoom-tools.html
riot.tag2('zoom-tools',
  '<button id="zoom-fit" class="zoom-button" data-tip="Center in view" data-tip-align="top" data-track="Zoom-Tools" data-track-action="Zoom-Center" data-track-label="Zoom" onclick="{opts.canvas.fitSelectionOrMap}"> <svg class="zoom-button_icon"> <use xlink:href="#zoom-out-map-icon"></use> </svg> </button> <button id="zoom-out" class="zoom-button" data-tip="Zoom out" data-tip-align="top" data-track="Zoom-Tools" data-track-action="Zoom-Out" data-track-label="Zoom"> <svg class="zoom-button_icon zoom-button_icon--small"> <use xlink:href="#minus-solid-icon"></use> </svg> </button> <button id="zoom-reset" class="zoom-button zoom-button--alt" data-tip="Reset zoom" data-tip-align="top" data-track="Zoom-Tools" data-track-action="Zoom-Reset" data-track-label="Zoom" onclick="{resetZoom}"> {getZoomLvl()}% </button> <button id="zoom-in" class="zoom-button" data-tip="Zoom in" data-tip-align="top" data-track="Zoom-Tools" data-track-action="Zoom-In" data-track-label="Zoom"> <svg class="zoom-button_icon zoom-button_icon--small"> <use xlink:href="#plus-solid-icon"></use> </svg> </button>',
  '',
  'id="zoom-tools" class="zoom-tools hideWhenPresenting" hide="{pageSettings.hideMapZoomControls}" riot-style="{pageSettings.isTryNow ? \'margin-right: 0;\' : \'\'}"', function(opts) {
'use strict';

var _zoomUi = require('lib/zoom-ui');

this.canvas = opts.canvas;
this.canvas.zoomToolsTag = this;

this.resetZoom = function () {
    return _zoomUi.zoomUI.resetZoom();
};
this.getZoomLvl = function () {
    return _zoomUi.zoomUI.currentScale * 100;
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('zoom-tools')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/zoom-tools.html
// module id = 675
// module chunks = 0